export default __webpack_public_path__ + "static/media/backgroundmobile.c02c78b3.png";